"use strict";
var Observable_1 = require("../../Observable");
var finally_1 = require("../../operator/finally");
Observable_1.Observable.prototype.finally = finally_1._finally;
Observable_1.Observable.prototype._finally = finally_1._finally;
//# sourceMappingURL=finally.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/rxjs/add/operator/finally.js
 ** module id = 309
 ** module chunks = 1
 **/